import React, { useEffect, useState, createContext, useContext } from 'react';
import { Coffee, CoffeeBag } from '../types';
interface CoffeeContextType {
  coffeeEntries: Coffee[];
  coffeeBags: CoffeeBag[];
  addCoffeeEntry: (entry: Coffee) => void;
  addCoffeeBag: (bag: CoffeeBag) => void;
  deleteCoffeeEntry: (id: string) => void;
  deleteCoffeeBag: (id: string) => void;
}
const CoffeeContext = createContext<CoffeeContextType | undefined>(undefined);
export const CoffeeProvider: React.FC<{
  children: React.ReactNode;
}> = ({
  children
}) => {
  const [coffeeEntries, setCoffeeEntries] = useState<Coffee[]>(() => {
    const saved = localStorage.getItem('coffeeEntries');
    return saved ? JSON.parse(saved) : [];
  });
  const [coffeeBags, setCoffeeBags] = useState<CoffeeBag[]>(() => {
    const saved = localStorage.getItem('coffeeBags');
    return saved ? JSON.parse(saved) : [];
  });
  useEffect(() => {
    localStorage.setItem('coffeeEntries', JSON.stringify(coffeeEntries));
  }, [coffeeEntries]);
  useEffect(() => {
    localStorage.setItem('coffeeBags', JSON.stringify(coffeeBags));
  }, [coffeeBags]);
  const addCoffeeEntry = (entry: Coffee) => {
    setCoffeeEntries([...coffeeEntries, entry]);
  };
  const addCoffeeBag = (bag: CoffeeBag) => {
    setCoffeeBags([...coffeeBags, bag]);
  };
  const deleteCoffeeEntry = (id: string) => {
    setCoffeeEntries(coffeeEntries.filter(entry => entry.id !== id));
  };
  const deleteCoffeeBag = (id: string) => {
    setCoffeeBags(coffeeBags.filter(bag => bag.id !== id));
  };
  return <CoffeeContext.Provider value={{
    coffeeEntries,
    coffeeBags,
    addCoffeeEntry,
    addCoffeeBag,
    deleteCoffeeEntry,
    deleteCoffeeBag
  }} data-id="element-437">
      {children}
    </CoffeeContext.Provider>;
};
export const useCoffee = () => {
  const context = useContext(CoffeeContext);
  if (context === undefined) {
    throw new Error('useCoffee must be used within a CoffeeProvider');
  }
  return context;
};